/* ============================================================
   HYPE SIDE — Dica "desliza" nos carrosséis (só telemóvel)

   Quando um carrossel horizontal aparece no ecrã pela primeira vez:
   a fila espreita para o lado e volta (peek) e aparece uma pílula
   "Desliza" com uma mão a mexer. Não anda sozinho: corre uma vez por
   carrossel e pára assim que o cliente toca. Respeita "reduzir movimento".
   ============================================================ */
(function () {
  if (!window.matchMedia('(max-width: 749px)').matches) return;
  var calmo = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var st = document.createElement('style');
  st.textContent =
    '.hs-swipe{position:absolute;right:1.2rem;z-index:3;display:flex;align-items:center;gap:.5rem;padding:.6rem 1.2rem .6rem .8rem;' +
    'border-radius:999px;background:rgba(17,17,17,.82);color:#fff;font-size:1.2rem;font-weight:700;letter-spacing:.02em;' +
    'pointer-events:none;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);box-shadow:0 6px 18px rgba(0,0,0,.18);' +
    'transform:translateY(-50%);animation:hs-swipe-in .35s cubic-bezier(.22,1,.36,1) both}' +
    '.hs-swipe.is-out{opacity:0;transform:translateY(-50%) scale(.9);transition:opacity .35s ease,transform .35s ease}' +
    '.hs-swipe__hand{display:grid;place-items:center;width:2.2rem;height:2.2rem;border-radius:50%;background:#00e05a;color:#06240f}' +
    '.hs-swipe__hand svg{width:1.5rem;height:1.5rem;animation:hs-swipe-hand 1.1s ease-in-out infinite}' +
    '@keyframes hs-swipe-in{from{opacity:0;transform:translate(1.2rem,-50%)}to{opacity:1;transform:translateY(-50%)}}' +
    '@keyframes hs-swipe-hand{0%,100%{transform:translateX(.25rem) rotate(0)}50%{transform:translateX(-.35rem) rotate(-12deg)}}' +
    '@media (prefers-reduced-motion:reduce){.hs-swipe,.hs-swipe__hand svg{animation:none}}';
  document.head.appendChild(st);

  var HAND =
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 11V5.5a1.5 1.5 0 0 1 3 0V10m0-.5V4.5a1.5 1.5 0 0 1 3 0V10m0-.5V6a1.5 1.5 0 0 1 3 0v7.5a6.5 6.5 0 0 1-6.5 6.5h-.4a6 6 0 0 1-4.8-2.4L4.6 13.4a1.5 1.5 0 0 1 2.3-1.9L9 13.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function eCarrossel(el) {
    if (el.scrollWidth - el.clientWidth < 40 || el.clientHeight < 40) return false;
    if (el.closest('[data-no-swipe-hint]')) return false;
    var o = getComputedStyle(el).overflowX;
    return (o === 'auto' || o === 'scroll') && el.children.length > 1;
  }

  function peek(el, done) {
    // alguns carrosséis começam a meio (infinitos, testemunhos): espreita a partir de onde está
    var inicio = el.scrollLeft;
    if (calmo) return done();
    var snap = el.style.scrollSnapType;
    var sb = el.style.scrollBehavior;
    el.style.scrollSnapType = 'none';
    el.style.scrollBehavior = 'auto';
    var dist = Math.min(72, el.scrollWidth - el.clientWidth - inicio);
    var t0 = null, dur = 1100, parar = false;
    function stop() { parar = true; }
    el.addEventListener('touchstart', stop, { once: true, passive: true });
    function frame(t) {
      if (parar) return fim();
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / dur);
      // vai e volta, com abrandamento suave
      var k = Math.sin(p * Math.PI);
      el.scrollLeft = inicio + dist * k * k;
      if (p < 1) requestAnimationFrame(frame); else fim();
    }
    function fim() {
      if (!parar) el.scrollLeft = inicio;
      el.style.scrollSnapType = snap;
      el.style.scrollBehavior = sb;
      done();
    }
    requestAnimationFrame(frame);
  }

  function pilula(el) {
    var pai = el.parentElement;
    if (!pai) return;
    if (getComputedStyle(pai).position === 'static') pai.style.position = 'relative';
    var chip = document.createElement('span');
    chip.className = 'hs-swipe';
    chip.innerHTML = '<span class="hs-swipe__hand">' + HAND + '</span>Desliza';
    var r = el.getBoundingClientRect(), rp = pai.getBoundingClientRect();
    chip.style.top = (r.top - rp.top + r.height / 2) + 'px';
    pai.appendChild(chip);
    function sair() {
      chip.classList.add('is-out');
      setTimeout(function () { chip.remove(); }, 400);
    }
    var timer = setTimeout(sair, 2800);
    // só depois do peek: o próprio movimento não conta como "o cliente deslizou"
    return function () {
      el.addEventListener('scroll', function () { clearTimeout(timer); sair(); }, { once: true, passive: true });
    };
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var el = en.target;
      io.unobserve(el);
      if (!eCarrossel(el)) return;
      setTimeout(function () {
        var depois = pilula(el);
        peek(el, function () { setTimeout(function () { depois && depois(); }, 120); });
      }, 250);
    });
  }, { threshold: 0.6 });

  function procurar() {
    var vistos = 0;
    document.querySelectorAll('main *, .menu-drawer *').forEach(function (el) {
      if (el.__hsSwipe || vistos > 40) return;
      if (eCarrossel(el)) { el.__hsSwipe = true; vistos++; io.observe(el); }
    });
  }

  if (document.readyState === 'complete') procurar();
  else window.addEventListener('load', procurar);
  // Menu do telemóvel: os escudos só têm tamanho quando o menu abre
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.header__icon--menu')) setTimeout(procurar, 400);
  });
})();
